export default "__VITE_ASSET__C1_pKWHY__"